import PDAHeader from "src/components/common/Header";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import { usePDA1122_R01Content } from "./PDA1122_R01Content";
import PDA1122_R01DetailInfo from "./PDA1122_R01DetailInfo";
import PDA1122_R01DetailTable from "./PDA1122_R01DetailTable";
import PDA1122_R01Search from "./PDA1122_R01Search";
import PDA1122_R01Table from "./PDA1122_R01Table";
import usePDA1122_R01Store from "./usePDA1122_R01Store";

interface Props {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1122_R01Container = ({ menuNm, menuCd, onBack }: Props) => {
  const { loading, reset, showList, orderList } = usePDA1122_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);
  const { handleSearch, handleSelectOrder, handleBackToList } = usePDA1122_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={showList ? onBack : handleBackToList}
        onMenuClick={handleMenuClick}
      />
      <div className="flex-1 overflow-hidden">
        {showList ? (
          <div className="h-full flex flex-col">
            <PDA1122_R01Search onSearch={handleSearch} />
            <div className="flex-1 overflow-hidden">
              <PDA1122_R01Table orderList={orderList} onSelectOrder={handleSelectOrder} />
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col">
            <PDA1122_R01DetailInfo />
            <div className="flex-1 overflow-hidden">
              <PDA1122_R01DetailTable />
            </div>
          </div>
        )}
      </div>
      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1122_R01Container;
